<template>
  <div>
    <selectors
      v-if="!single"
      :selectKey="'title'"
      :modal="modal"
      v-model="val"
      :title="title"
      @input="input"
      :prefix="'_filter'"
    />
    <selector
      v-else
      :selectKey="'title'"
      :modal="modal"
      v-model="val"
      :title="title"
      @input="input"
      :prefix="'_filter'"
    />
  </div>
</template>
<script>
export default {
  props: {
    modal: {
      default: "",
    },
    single: {
      default: false,
    },
    title: {
      default: "",
    },
  },
  name: "filter",
  components: {
    selectors: () => import("./Inputs/Selectors"),
  },
  methods: {
    input() {

      if (!this.single){
       let value = [];
      for (let i = 0; i < this.val.length; i++) {
        value.push(this.val[i].id);
      }
      this.$emit("input", value.join("-"));
      }else {
        let value = (this.val && this.val['id']) ? this.val['id']: null;
        this.$emit("input",value );
      }

    
    },
  },
  data() {
    return {
      val: [],
    };
  },
};
</script>
<style>
</style>
